export interface Link {
  readonly id: string;
  readonly name: string;
  readonly safe_id: string;
  readonly link_parameter: string[];
  readonly link_data: string[];
  readonly merge?: string | null;
}

export const LinkUtils = {
  create({
    id,
    name,
    safe_id,
    link_parameter,
    link_data,
    merge,
  }: {
    id: string;
    name: string;
    safe_id: string;
    link_parameter: string[];
    link_data: string[];
    merge?: string | null;
  }): Link {
    return {
      id,
      name,
      safe_id,
      link_parameter,
      link_data,
      merge,
    };
  },

  fromMap(map: Record<string, any>): Link {
    return {
      id: map["id"] ?? "",
      name: map["name"] ?? "",
      safe_id: map["safe_id"] ?? "",
      link_parameter:
        map["link_parameter"] != null && map["link_parameter"] !== ""
          ? (map["link_parameter"] as any[]).map(String)
          : [],
      link_data:
        map["link_data"] != null && map["link_data"] !== ""
          ? (map["link_data"] as any[]).map(String)
          : [],
      merge: map["merge"] ?? undefined,
    };
  },

  toMap(link: Link): Record<string, any> {
    const map: Record<string, any> = {
      id: link.id,
      name: link.name,
      safe_id: link.safe_id,
      link_parameter: link.link_parameter,
      link_data: link.link_data,
    };
    if (link.merge !== undefined && link.merge !== null) {
      map["merge"] = link.merge;
    }
    return map;
  },

  toJson(link: Link): string {
    return JSON.stringify(LinkUtils.toMap(link));
  },

  empty(): Link {
    return {
      id: "",
      name: "",
      safe_id: "",
      link_parameter: [],
      link_data: [],
      merge: undefined,
    };
  },

  emptyWithSafeId({ safe_id }: { safe_id: string }): Link {
    return {
      id: "",
      name: "",
      safe_id,
      link_parameter: [],
      link_data: [],
      merge: undefined,
    };
  },

  linkForNewUser(): Link {
    return LinkUtils.create({
      id: `##public_key`,
      name: "profileLink",
      safe_id: "##public_key",
      link_parameter: ["profile", "safes", "public_key", "update_user_address_slot"],
      link_data: ["params", "safes", "public_key", "update_user_address_slot"],
      merge: "true",
    });
  },

  fromJson(source: string): Link {
    return LinkUtils.fromMap(JSON.parse(source));
  },

  toString(link: Link): string {
    return `Link("id":${link.id}, "name":${link.name}, "safe_id":${
      link.safe_id
    }, "link_parameter":${JSON.stringify(
      link.link_parameter
    )}, "link_data":${JSON.stringify(link.link_data)})`;
  },
};
